import React from 'react';
import { Navigate } from 'react-router-dom';
import { useClientCountry } from '../hooks/useClientCountry';

/** Vehicle marketplace and other Canada-only app pages. */
export const CanadaOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { country } = useClientCountry();
  if (country !== 'CA') return <Navigate to="/" replace />;
  return <>{children}</>;
};
